import * as NspActions from './../actions/nsp.actions';
import { TechnicalError } from '@dch/products-business-logic';
import { INspPrices, INspStatistics, INspValues } from '../../utils/nsp.utils';

export interface NspState {
  packId: string;
  plcList: string[];
  productId: string;
  productsInPack: any;
  isPendingInPack: boolean;
  errorInPack: TechnicalError;
  standaloneProducts: any;
  isPendingStandalone: boolean;
  errorStandalone: TechnicalError;
  internetNspValues: INspValues;
  mobileNspValues: INspValues;
  nspPrices: INspPrices;
  statisticsProducts: INspStatistics;
  isPendingStatistics: boolean;
  errorStatistics: TechnicalError;
}

export const initialState: NspState = {
  packId: null,
  plcList: null,
  productId: null,
  productsInPack: [],
  isPendingInPack: false,
  errorInPack: null,
  standaloneProducts: [],
  isPendingStandalone: false,
  errorStandalone: null,
  internetNspValues: null,
  mobileNspValues: null,
  nspPrices: null,
  statisticsProducts: null,
  isPendingStatistics: false,
  errorStatistics: null,
};

export function reducer(
  state: NspState = initialState,
  action: NspActions.Actions,
): NspState {
  switch (action.type) {
    case NspActions.GET_NSP_PRODUCTS_IN_PACK:
      if (state.packId === action.payload.packId) {
        return {
          ...state,
          isPendingInPack: true,
          errorInPack: null,
        };
      } else {
        return {
          ...state,
          packId: action.payload.packId,
          productId: null,
          plcList: null,
          productsInPack: [],
          standaloneProducts: [],
          internetNspValues: null,
          mobileNspValues: null,
          isPendingInPack: true,
          errorInPack: null,
          errorStandalone: null,
        };
      }
    case NspActions.GET_NSP_PRODUCTS_IN_PACK_SUCCESS:
      return {
        ...state,
        productsInPack: action.payload.products,
        nspPrices: action.payload.nspPrices,
        isPendingInPack: false,
        errorInPack: null,
      };
    case NspActions.GET_NSP_PRODUCTS_IN_PACK_FAILED:
      return {
        ...state,
        productsInPack: null,
        errorInPack: action.payload,
        isPendingInPack: false,
      };

    case NspActions.GET_NSP_STANDALONE_PRODUCTS:
      if (
        state.productId === action.payload.productId &&
        state.plcList === action.payload.plcList
      ) {
        return {
          ...state,
          isPendingStandalone: true,
          errorStandalone: null,
        };
      } else {
        return {
          ...state,
          packId: null,
          productId: action.payload.productId,
          plcList: action.payload.plcList,
          productsInPack: [],
          standaloneProducts: [],
          internetNspValues: null,
          mobileNspValues: null,
          isPendingStandalone: true,
          errorInPack: null,
          errorStandalone: null,
        };
      }
    case NspActions.GET_NSP_STANDALONE_PRODUCTS_SUCCESS:
      return {
        ...state,
        standaloneProducts: action.payload.products,
        nspPrices: action.payload.nspPrices,
        isPendingStandalone: false,
        errorStandalone: null,
      };
    case NspActions.GET_NSP_STANDALONE_PRODUCTS_FAILED:
      return {
        ...state,
        standaloneProducts: null,
        errorStandalone: action.payload,
        isPendingStandalone: false,
      };
    case NspActions.UPDATE_INTERNET_NSP_VALUES:
      return {
        ...state,
        internetNspValues: action.payload,
      };
    case NspActions.UPDATE_MOBILE_NSP_VALUES:
      return {
        ...state,
        mobileNspValues: action.payload,
      };
    case NspActions.GET_NSP_STATISTICS_PRODUCTS:
      return {
        ...state,
        isPendingStatistics: true,
        errorStatistics: null,
      };
    case NspActions.GET_NSP_STATISTICS_PRODUCTS_SUCCESS:
      return {
        ...state,
        statisticsProducts: action.payload,
        isPendingStatistics: false,
        errorStatistics: null,
      };
    case NspActions.GET_NSP_STATISTICS_PRODUCTS_FAILED:
      return {
        ...state,
        statisticsProducts: null,
        isPendingStatistics: false,
        errorStatistics: action.payload,
      };
    default:
      return state;
  }
}

export const getNspProductsInPack = (state: NspState) => state.productsInPack;
export const getNspProductsInPackTechnicalError = (state: NspState) =>
  state.errorInPack;
export const getNspProductsInPackPending = (state: NspState) =>
  state.isPendingInPack;
export const getNspStandaloneProducts = (state: NspState) =>
  state.standaloneProducts;
export const getNspStandaloneTechnicalError = (state: NspState) =>
  state.errorStandalone;
export const getNspStandaloneProductsPending = (state: NspState) =>
  state.isPendingStandalone;
export const getNspInternetValues = (state: NspState) =>
  state.internetNspValues;
export const getNspMobileValues = (state: NspState) => state.mobileNspValues;
export const getNspPrices = (state: NspState) => state.nspPrices;

export const getNspStatisticsWithStatus = ({
  statisticsProducts,
  isPendingStatistics,
  errorStatistics,
}: NspState) => ({
  statisticsProducts,
  isPendingStatistics,
  errorStatistics,
});
